/**
 * @generated SignedSource<<c8feb3e3b230e016b49ff241789196d4>>
 * @relayHash 446ffd2991ac0a50e0a16f4f22e9d529
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca82ea6b5cf3f717151a9cf554cb7b366e70357c10a0104135bb4a2c3357c642

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraAttachmentFilterInput = {
  authorIds?: ReadonlyArray<string> | null | undefined;
  dateRange?: JiraDateTimeRange | null | undefined;
  fileName?: string | null | undefined;
  mimeTypes?: ReadonlyArray<string> | null | undefined;
};
export type JiraDateTimeRange = {
  after?: AGG$DateTime | null | undefined;
  before?: AGG$DateTime | null | undefined;
};
export type uiJWMAttachmentsQuery$variables = {
  attachmentCount: number;
  cloudId: string;
  count: number;
  durationInSeconds: number;
  filters: JiraAttachmentFilterInput;
  isAttachmentsM2Enabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  maxTokenLength: number;
  projectKey: ReadonlyArray<string>;
};
export type uiJWMAttachmentsQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"grid_businessAttachments_GridAttachment_jiraQuery" | "grid_businessAttachments_GridJiraIssue_jiraQuery">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"grid_businessAttachments_GridAttachment_query" | "grid_businessAttachments_GridJiraIssue_query">;
};
export type uiJWMAttachmentsQuery = {
  response: uiJWMAttachmentsQuery$data;
  variables: uiJWMAttachmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attachmentCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationInSeconds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAttachmentsM2Enabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxTokenLength"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "Variable",
  "name": "attachmentCount",
  "variableName": "attachmentCount"
},
v12 = {
  "kind": "Variable",
  "name": "durationInSeconds",
  "variableName": "durationInSeconds"
},
v13 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v14 = {
  "kind": "Variable",
  "name": "maxTokenLength",
  "variableName": "maxTokenLength"
},
v15 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v16 = [
  {
    "args": (v10/*: any*/),
    "kind": "ScalarField",
    "name": "mediaClientId"
  },
  {
    "args": (v10/*: any*/),
    "kind": "ScalarField",
    "name": "mediaExternalEndpointUrl"
  }
],
v17 = [
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v13/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "message"
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "attachmentCount"
},
v22 = {
  "kind": "ScalarField",
  "name": "id"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fileName"
    },
    {
      "kind": "ScalarField",
      "name": "mediaApiFileId"
    },
    {
      "kind": "ScalarField",
      "name": "attachmentId"
    },
    {
      "args": [
        (v12/*: any*/),
        (v14/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "mediaReadToken"
    },
    {
      "kind": "ScalarField",
      "name": "parentName"
    },
    (v22/*: any*/),
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v22/*: any*/)
      ]
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isJiraAttachment"
    }
  ],
  "type": "JiraPlatformAttachment"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v25 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "alias": "fields",
  "args": [
    {
      "kind": "Literal",
      "name": "ids",
      "value": [
        "summary",
        "issuetype"
      ]
    }
  ],
  "concreteType": "JiraIssueFieldConnection",
  "kind": "LinkedField",
  "name": "fieldsById",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "kind": "ScalarField",
              "name": "fieldId"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "text"
                }
              ],
              "type": "JiraSingleLineTextField"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "concreteType": "JiraAvatar",
                      "kind": "LinkedField",
                      "name": "avatar",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "xsmall"
                        }
                      ]
                    },
                    (v22/*: any*/)
                  ]
                }
              ],
              "type": "JiraIssueTypeField"
            },
            (v22/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\"])"
},
v28 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v29 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v30 = [
  (v9/*: any*/),
  (v15/*: any*/),
  (v21/*: any*/),
  {
    "kind": "Variable",
    "name": "projectKeys",
    "variableName": "projectKey"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiJWMAttachmentsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "isAttachmentsM2Enabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": (v10/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "grid_businessAttachments_GridJiraIssue_jiraQuery"
                }
              ]
            },
            {
              "condition": "isAttachmentsM2Enabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": (v10/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "grid_businessAttachments_GridAttachment_jiraQuery"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "condition": "isAttachmentsM2Enabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v11/*: any*/),
              (v9/*: any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "grid_businessAttachments_GridJiraIssue_query"
          }
        ]
      },
      {
        "condition": "isAttachmentsM2Enabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v11/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              (v15/*: any*/),
              (v14/*: any*/),
              {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
              }
            ],
            "kind": "FragmentSpread",
            "name": "grid_businessAttachments_GridAttachment_query"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiJWMAttachmentsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAttachmentsM2Enabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v16/*: any*/)
          },
          {
            "condition": "isAttachmentsM2Enabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v16/*: any*/)
          }
        ]
      },
      {
        "condition": "isAttachmentsM2Enabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "issues",
                "args": (v17/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearchStable",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "issueSearchError",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "messages"
                          }
                        ],
                        "type": "JiraInvalidJqlError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v20/*: any*/),
                        "type": "JiraInvalidSyntaxError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v20/*: any*/),
                        "type": "JiraServerError"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v21/*: any*/)
                            ],
                            "concreteType": "JiraAttachmentConnection",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAttachmentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v26/*: any*/),
                          (v22/*: any*/),
                          (v27/*: any*/),
                          (v18/*: any*/)
                        ]
                      },
                      (v28/*: any*/)
                    ]
                  },
                  (v29/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "alias": "issues",
                "args": (v17/*: any*/),
                "filters": [
                  "cloudId",
                  "issueSearchInput"
                ],
                "handle": "connection",
                "key": "JiraIssuesFragment_issues",
                "kind": "LinkedHandle",
                "name": "issueSearchStable"
              }
            ]
          }
        ]
      },
      {
        "condition": "isAttachmentsM2Enabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v30/*: any*/),
                "concreteType": "JiraAttachmentConnection",
                "kind": "LinkedField",
                "name": "attachmentSearch",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraAttachmentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v22/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ]
                      },
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          }
                        ]
                      }
                    ]
                  },
                  (v29/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "args": (v30/*: any*/),
                "filters": [
                  "cloudId",
                  "projectKeys",
                  "filters"
                ],
                "handle": "connection",
                "key": "JiraAttachmentsFragment_attachmentSearch",
                "kind": "LinkedHandle",
                "name": "attachmentSearch"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ca82ea6b5cf3f717151a9cf554cb7b366e70357c10a0104135bb4a2c3357c642",
    "metadata": {},
    "name": "uiJWMAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a616ae3680f58253e9f34b7d827defa9";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
